import * as React from 'react';

const SvgWorldRoaming = (props) => (
  <svg
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width={56} height={56} rx={28} fill='#E00034' />
    <path
      d='M28 14.667c-7.334 0-13.334 6-13.334 13.333s6 13.333 13.333 13.333c7.334 0 13.334-6 13.334-13.333s-6-13.333-13.334-13.333Zm0 2.666c.8 0 1.6.134 2.4.267-.267.533-.534.933-1.067 1.333-.267.267-.667.4-.934.667-1.066.533-1.866 1.333-2.533 2.267-.667 1.333-.933 2.933-.8 4.4 0 1.866 0 2.933-1.2 3.866-1.867 1.467-4.667.667-6.4-.133-.133-.667-.133-1.333-.133-2 0-5.867 4.8-10.667 10.666-10.667ZM34.532 36.4c-.267-.533-.534-1.067-.8-1.467-.134-.266-.267-.4-.4-.666-.534-.934-.267-1.334.533-2.667l.133-.267c.534-.933.8-2.133.8-3.2 0-.4 0-.933.134-1.333.266-.933 2.266-1.2 3.6-1.333.933 4.133-.667 8.4-4 10.933Z'
      fill='#fff'
    />
  </svg>
);

export default SvgWorldRoaming;
